/* ═══════════════════════════════════════════
   THE WEDDING TOKEN — Custom JS for Dawn Theme
   Ported from custom theme v7.29
   NOTE: Product variant JS removed — Dawn handles variants natively
   ═══════════════════════════════════════════ */

/* Preloader */
window.addEventListener('load',function(){setTimeout(function(){var p=document.querySelector('.preloader');if(p)p.classList.add('hidden')},1200)});

/* Scroll nav — only on homepage (nav-solid pages don't need scroll behavior) */
window.addEventListener('scroll',function(){var n=document.querySelector('.twt-nav');if(n&&!n.classList.contains('nav-solid'))n.classList.toggle('scrolled',window.scrollY>50)});

document.addEventListener('DOMContentLoaded',function(){
/* Mobile menu */
var mb=document.querySelector('.mobile-menu-btn');if(mb)mb.addEventListener('click',function(){document.querySelector('.nav-links').classList.toggle('show')});
document.querySelectorAll('.nav-links a').forEach(function(a){a.addEventListener('click',function(){var nl=document.querySelector('.nav-links');if(nl)nl.classList.remove('show')})});

/* Scroll reveal animation */
var els=document.querySelectorAll('.reveal');
var obs=new IntersectionObserver(function(entries){entries.forEach(function(e,i){if(e.isIntersecting){setTimeout(function(){e.target.classList.add('visible')},i*80);obs.unobserve(e.target)}})},{threshold:.1});
els.forEach(function(el){obs.observe(el)});

/* Smooth scroll for anchor links */
document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var h=this.getAttribute('href');if(h==='#')return;e.preventDefault();var t=document.querySelector(h);if(t)t.scrollIntoView({behavior:'smooth',block:'start'})})});

/* Image preview for card-order-form (legacy submit page) */
var fi=document.getElementById('field-image'),pc=document.getElementById('image-preview-container'),pt=document.getElementById('image-preview-thumb'),ua=document.getElementById('image-upload-area');
if(fi)fi.addEventListener('change',function(e){var f=e.target.files[0];if(f){var r=new FileReader();r.onload=function(ev){pt.src=ev.target.result;pc.style.display='block';ua.style.display='none'};r.readAsDataURL(f)}});

/* Card order form (legacy mailto submit) */
var form=document.getElementById('card-order-form');
if(form)form.addEventListener('submit',function(e){e.preventDefault();var f={'Finish Type':document.getElementById('field-finish').value,'Foil Type':document.getElementById('field-foil').value,'Card Style':document.getElementById('field-style').value,'Card Title':document.getElementById('field-title').value,'Vow Cost':document.getElementById('field-mana').value,'Nickname':document.getElementById('field-nickname').value,'Card Type':document.getElementById('field-type').value,'Rules Text':document.getElementById('field-rules').value,'Flavor Quote':document.getElementById('field-flavor').value,'Power/Toughness':document.getElementById('field-pt').value,'Artist Credit':document.getElementById('field-artist').value,'Quantity':document.getElementById('field-quantity').value,'Contact Email':document.getElementById('field-email').value,'Additional Notes':document.getElementById('field-notes').value};var b='NEW CARD ORDER\n\n';for(var k in f){if(f[k])b+=k+': '+f[k]+'\n'}b+='\n(Customer image attached separately)';window.location.href='mailto:mario@theweddingtoken.com?subject='+encodeURIComponent('New Card Order - '+f['Card Title'])+'&body='+encodeURIComponent(b)});
});

/* ═══════════════════════════════════════════
   HOLOGRAPHIC TILT CARD — Hero
   ═══════════════════════════════════════════ */
(function(){
  var card = document.getElementById('holo-card');
  if (!card) return;
  var shine = card.querySelector('.holo-shine');
  var sparkle = card.querySelector('.holo-sparkle');
  var isTouch = 'ontouchstart' in window;

  if (isTouch) {
    card.classList.add('active');
    if (shine) shine.style.opacity = '0.5';
    return;
  }

  card.addEventListener('mouseenter', function() {
    card.style.animation = 'none';
    card.classList.add('active');
  });

  card.addEventListener('mouseleave', function() {
    card.style.animation = '';
    card.style.transform = '';
    card.classList.remove('active');
    if (shine) { shine.style.background = ''; shine.style.opacity = '0'; }
    if (sparkle) { sparkle.style.opacity = '0'; }
  });

  card.addEventListener('mousemove', function(e) {
    var rect = card.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    var centerX = rect.width / 2;
    var centerY = rect.height / 2;
    var rotateX = ((y - centerY) / centerY) * -12;
    var rotateY = ((x - centerX) / centerX) * 12;

    card.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';

    var pctX = (x / rect.width) * 100;
    var pctY = (y / rect.height) * 100;

    if (shine) {
      shine.style.background = 'linear-gradient(' + (120 + rotateY * 3) + 'deg, ' +
        'transparent 0%, transparent 25%, rgba(255,220,180,.15) 40%, ' +
        'rgba(200,180,255,.12) 50%, rgba(180,255,220,.1) 60%, transparent 75%, transparent 100%)';
      shine.style.opacity = '1';
    }
    if (sparkle) {
      sparkle.style.background = 'radial-gradient(circle at ' + pctX + '% ' + pctY + '%, rgba(255,215,0,.12) 0%, transparent 50%)';
      sparkle.style.opacity = '1';
    }
  });
})();

/* ═══════════════════════════════════════════
   SHOPIFY NEWSLETTER SIGNUP (AJAX, no redirect)
   ═══════════════════════════════════════════ */
function twtSubscribe(email, onSuccess, onError) {
  var formData = new FormData();
  formData.append('form_type', 'customer');
  formData.append('utf8', '\u2713');
  formData.append('customer[email]', email);
  formData.append('customer[tags]', 'newsletter');

  fetch('/contact', {
    method: 'POST',
    body: formData,
    headers: { 'Accept': 'application/json' }
  }).then(function(res) {
    if (onSuccess) onSuccess();
  }).catch(function() {
    if (onError) onError();
  });
}

/* ─── POPUP ─── */
(function(){
  var overlay = document.getElementById('email-popup-overlay');
  if (!overlay) return;
  if (localStorage.getItem('twt_popup_dismissed')) return;

  var closeBtn = overlay.querySelector('.email-popup-close');
  var emailInput = document.getElementById('popup-email');
  var submitBtn = document.getElementById('popup-submit');
  var successMsg = document.getElementById('popup-success');

  function dismiss() {
    overlay.classList.remove('active');
    localStorage.setItem('twt_popup_dismissed', '1');
  }

  if (closeBtn) closeBtn.addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) dismiss();
  });

  if (submitBtn && emailInput) {
    submitBtn.addEventListener('click', function() {
      var email = emailInput.value.trim();
      if (!email || !email.includes('@')) return;
      submitBtn.textContent = 'Subscribing...';
      submitBtn.disabled = true;
      twtSubscribe(email, function() {
        emailInput.style.display = 'none';
        submitBtn.style.display = 'none';
        if (successMsg) successMsg.style.display = 'block';
        localStorage.setItem('twt_popup_dismissed', '1');
        setTimeout(function() { overlay.classList.remove('active'); }, 3000);
      }, function() {
        submitBtn.textContent = 'Try Again';
        submitBtn.disabled = false;
      });
    });
    emailInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') submitBtn.click();
    });
  }

  var shown = false;
  function showPopup() {
    if (shown) return;
    shown = true;
    overlay.classList.add('active');
  }
  setTimeout(showPopup, 30000);
  window.addEventListener('scroll', function() {
    var scrollPct = window.scrollY / (document.body.scrollHeight - window.innerHeight);
    if (scrollPct > 0.6) showPopup();
  });
})();

/* ─── ALL INLINE / FOOTER NEWSLETTER FORMS ─── */
(function(){
  var forms = document.querySelectorAll('[data-newsletter-form]');
  forms.forEach(function(form) {
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button');
    var success = form.querySelector('.newsletter-success');
    if (!input || !btn) return;
    btn.addEventListener('click', function() {
      var email = input.value.trim();
      if (!email || !email.includes('@')) return;
      var origText = btn.textContent;
      btn.textContent = 'Subscribing...';
      btn.disabled = true;
      twtSubscribe(email, function() {
        input.style.display = 'none';
        btn.style.display = 'none';
        if (success) success.style.display = 'block';
      }, function() {
        btn.textContent = origText;
        btn.disabled = false;
      });
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') btn.click();
    });
  });
})();
